/**
 * Route → event_action for every side-nav destination, named per the mentor
 * tracking sheet's nav_* scheme.
 *
 * ELEVEN existing events are renamed here, so every GTM trigger and report on
 * an old name stops receiving data until it is pointed at the new one:
 *   dashboard_loaded   → nav_dashboard_clicked
 *   demos_clicked      → nav_demos_clicked
 *   classes_opened     → nav_classes_clicked
 *   timetable_opened   → nav_timetable_clicked
 *   resources_opened   → nav_resources_clicked
 *   community_clicked  → nav_community_clicked
 *   mentors_clicked    → nav_profile_clicked
 *   slots_clicked      → nav_slots_clicked
 *   loop_clicked       → nav_loop_clicked
 *   referrals_clicked  → nav_referral_clicked
 *   payout_clicked     → nav_payout_clicked
 *
 * A route that isn't listed keeps navigateTo's previous "/" fallback — which is
 * why the map lives in its own module with a test: a renamed route or a typo
 * here sends the wrong event, or none, and nothing else in the app notices.
 */
export const NAV_GTM_ACTIONS = {
  "/mentorDashboard": "nav_dashboard_clicked",
  "/my-courses": "nav_tutorials_clicked",
  "/slots": "nav_slots_clicked",
  "/demos": "nav_demos_clicked",
  "/classes": "nav_classes_clicked",
  "/timetable": "nav_timetable_clicked",
  "/student-manage": "nav_students_clicked",
  "/loop": "nav_loop_clicked",
  "/mentorResources": "nav_resources_clicked",
  "/community": "nav_community_clicked",
  "/chat": "nav_chat_clicked",
  "/mentors": "nav_profile_clicked",
  "/referral": "nav_referral_clicked",
  "/payout": "nav_payout_clicked",
  "/tasks": "nav_tasks_clicked",
};

export default NAV_GTM_ACTIONS;
